export const linksEncuestasFormModel = {
    formId: 'linksEncuestasForm',
    formField: {
        name: {
            name: 'name',
            label: 'Nombre del enlace *',
            requiredErrorMsg: 'El nombre del enlace es requerido'
        },
        description: {
            name: 'description',
            label: 'Descripción *',
            requiredErrorMsg: 'La descripción es requerida'
        },
        surveyId: {
            name: 'surveyId',
            label: 'Encuesta *',
            requiredErrorMsg: 'La encuesta es requerida'
        },
        userId: {
            name: 'userId',
            label: 'Usuario *',
            requiredErrorMsg: 'El usuario es requerido'
        },
        fechaEvento: {
            name: 'fechaEvento',
            label: 'Fecha del Evento'
        },
        nombreEvento: {
            name: 'nombreEvento',
            label: 'Nombre del Evento'
        },
        nombreCliente: {
            name: 'nombreCliente',
            label: 'Nombre del Cliente'
        },
        telefonoCliente: {
            name: 'telefonoCliente',
            label: 'Teléfono del Cliente',
            invalidErrorMsg: 'El teléfono debe ser un número válido'
        },
        emailCliente: {
            name: 'emailCliente',
            label: 'Email del Cliente',
            invalidErrorMsg: 'El email no es válido'
        },
        diaNacimiento: {
            name: 'diaNacimiento',
            label: 'Día de Nacimiento'
        },
        mesNacimiento: {
            name: 'mesNacimiento',
            label: 'Mes de Nacimiento'
        },
        shareTemplate: {
            name: 'shareTemplate',
            label: 'Plantilla Compartir WhatsApp'
        }
    }
};
